module.exports = __webpack_public_path__ + "img/icon_white_mail-invitation.b2a0e721.svg";